import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

/** 배지 — 상태는 옅은 바탕 + 진한 글자, 값 표시는 outline. */
const BADGE_VARIANT = {
  neutral: "bg-clay-action-primary-tonal text-clay-text",
  success: "bg-clay-surface-success-secondary text-clay-text-success",
  warning: "bg-clay-surface-warning-secondary text-clay-text-warning",
  danger: "bg-clay-surface-critical-secondary text-clay-text-critical",
  info: "bg-clay-surface-highlight-secondary text-clay-text-accent",
  /** 숫자·값을 담는 칩 — 면 없이 옅은 선만. */
  outline: "bg-clay-surface text-clay-text ring ring-clay-divide-minimal",
} as const;

export type BadgeVariant = keyof typeof BADGE_VARIANT;

export function Badge({
  variant = "neutral",
  className,
  children,
}: {
  variant?: BadgeVariant;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        BADGE_VARIANT[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
